export const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop);

export const iOS = (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) || (/Macintosh/.test(navigator.userAgent) && "ontouchend" in document);
